import React from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation, Navigate } from 'react-router-dom';
import Sidebar from './components/Sidebar';
import Invoice from './components/Invoice';
import Supplier from './components/Supplier';
import SuppliersLedger from './components/SuppliersLedger';
import Firms from './components/Firms';
import CustomerLedger from './components/CustomerLedger';
import AuthForm from './components/AuthForm';
import ProtectedRoute from './components/ProtectedRoute';
import Logout from './components/Logout';
import AdminUsers from './components/AdminUsers';
import ServiceLocations from './components/ServiceLocation';
import CreditNote from './components/CreditNote';
import Reporting from './components/Reporting';
import Analytics from './components/Analytics';
import Upload from './components/Upload';
import Products from './components/Products';
import WhatsAppNotifications from './components/WhatsAppNotifications';
import DatabaseBackup from './components/DatabaseBackup';
import { setFavicon, resetFavicon } from './utils/setFavicon';
import { useEffect } from 'react';

const Layout = () => {
  const location = useLocation();
  const token = localStorage.getItem('token');

  const isAuthPage = location.pathname === '/auth';

  return (
    <div style={{ display: 'flex' }}>
      {!isAuthPage && token && <Sidebar />}
      <div style={{ padding: '20px', width: '100%' }}>
        <Routes>
          <Route
            path="/auth"
            element={
              token ? <Navigate to="/" replace /> : <AuthForm />
            }
          />
          <Route
            path="/logout"
            element={<Logout />}
          />
          <Route
            path="/invoices"
            element={
              <ProtectedRoute>
                <Invoice />
              </ProtectedRoute>
            }
          />
          <Route
            path="/suppliers"
            element={
              <ProtectedRoute>
                <Supplier />
              </ProtectedRoute>
            }
          />
          <Route
            path="/suppliers-ledger"
            element={
              <ProtectedRoute>
                <SuppliersLedger />
              </ProtectedRoute>
            }
          />
          <Route
            path="/firms"
            element={
              <ProtectedRoute>
                <Firms />
              </ProtectedRoute>
            }
          />
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <Analytics />
              </ProtectedRoute>
            }
          />
          <Route
            path="/customer-ledger"
            element={
              <ProtectedRoute>
                <CustomerLedger />
              </ProtectedRoute>
            }
          />
          <Route
            path="/analytics"
            element={
              <ProtectedRoute>
                <Analytics />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <AdminUsers />
              </ProtectedRoute>
            }
          />
          <Route
            path="/service-location"
            element={
              <ProtectedRoute>
                <ServiceLocations />
              </ProtectedRoute>
            }
          />
          <Route
            path="/credit-notes"
            element={
              <ProtectedRoute>
                <CreditNote />
              </ProtectedRoute>
            }
          />
          <Route
            path="/reporting"
            element={
              <ProtectedRoute>
                <Reporting />
              </ProtectedRoute>
            }
          />
          <Route
            path="/upload"
            element={
              <ProtectedRoute>
                <Upload />
              </ProtectedRoute>
            }
          />
          <Route
            path="/products"
            element={
              <ProtectedRoute>
                <Products />
              </ProtectedRoute>
            }
          />
          <Route
            path="/whatsapp-notifications"
            element={
              <ProtectedRoute>
                <WhatsAppNotifications />
              </ProtectedRoute>
            }
          />
          <Route
            path="/database-backup"
            element={
              <ProtectedRoute>
                <DatabaseBackup />
              </ProtectedRoute>
            }
          />
        </Routes>
      </div>
    </div>
  );
};

const App = () => {
  useEffect(() => {
    const pref = localStorage.getItem('faviconPreference');
    if (pref) {
      const parsed = JSON.parse(pref);
      if (parsed.type === 'firm' && parsed.logo) {
        setFavicon(parsed.logo);
      } else {
        resetFavicon();
      }
    } else {
      resetFavicon();
    }
  }, []);

  return (
    <Router>
      <Layout />
    </Router>
  );
};

export default App;
